export default {"src":"/_next/static/media/google-icon.98d02e43.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};